export default __webpack_public_path__ + "static/media/dropdown_signout_icon.a806b9a0.svg";